import { Box, Card, Grid, Typography, Chip, Divider } from '@mui/material';
import { useState } from 'react';
import { showModal } from 'react-redux-modal-provider';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FechaFunction from '../../function/FechaFunction';
import ModalEstadoSoftland from '../../modals/servicio/ModalEstadoSoftland';
import TratoService from '../../services/tratos.service';
import ButtonBasic from '../buttons/ButtonBasic';
import TextEstadoServicio from '../text/TextEstadoServicio';
import usePermisos from '../../hooks/usePermisos';
import ConfirmationDialog from '../../modals/default/ConfirmationDialog';

const CardCuentaProducto = ({
    item,
    numero,
    onGuardar
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const permisos = usePermisos();
    const onOpenModalEstadoSoft = () =>{
        showModal(ModalEstadoSoftland,{extension:numero, servicio: item[0],onGuardar: onGuardar })
    }
    const onActivarEstadoSoft = async() =>{
        setIsLoading(true)
        const form = {
            tipoContrato: item[0].tipo,
            contratoId: item[0].numero,
            nroExt: numero,
            estado: '01',
        }
        await TratoService.changeEstadoSoftland(form).then(()=>{
            setIsLoading(false)
            onGuardar()
        }).catch(()=>{
            setIsLoading(false)
        })
    }
    const onOpenModalActivar = () =>{
        showModal(ConfirmationDialog,{
            title: 'Esta por activar el servicio',
            message: '¿Esta seguro que desea continuar? Al confirmar se llevara a cabo el proceso de activacion en softland.',
            onConfirm: onActivarEstadoSoft
        })
    }
    return (
        <Card 
            sx={{
                background: '#ffffff !important',
                p: 2,
                borderRadius: 2,
                boxShadow: '0 1px 3px rgba(15, 41, 75, 0.1)',
                border: '1px solid #e5e7eb'
            }}
        >
            {/* Header minimalista con borde izquierdo */}
            <Box 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    mb: 2,
                    pb: 1.5,
                    borderLeft: '4px solid #0364ff',
                    pl: 1.5,
                    borderBottom: '1px solid #f3f4f6'
                }}
            >
                <Typography 
                    sx={{
                        color: '#15294b',
                        fontWeight: 700,
                        fontSize: '1.1rem',
                        letterSpacing: '-0.02em'
                    }}
                >
                    Extensión {numero}
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.75 }}>
                    {item?.length > 0 && item[0]?.estado?.codigo === '01' && permisos['softland.bajaSuspension'] && (
                        <ButtonBasic
                            textButton='Baja/Suspensión'
                            onClick={() => onOpenModalEstadoSoft()}
                            variant='wk'
                            color='error'
                            sx={{ 
                                fontSize: '0.813rem',
                                py: 0.5,
                                px: 1.5,
                                minHeight: 32,
                            }}
                        />
                    )}
                    {item?.length > 0 && (item[0]?.estado?.codigo === '02' || item[0]?.estado?.codigo === '03' || item[0]?.estado?.codigo === '04') && permisos['softland.activarServicio'] && (
                        <ButtonBasic
                            textButton='Activar'
                            onClick={() => onOpenModalActivar()}
                            variant='wk'
                            color='nextStep'
                            sx={{ 
                                fontSize: '0.813rem',
                                py: 0.5,
                                px: 1.5,
                                minHeight: 32
                            }}
                        />
                    )}
                </Box>
            </Box>

            {/* Stack de servicios */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {item && item?.length > 0 && item.map((it, index) => {
                    const isActive = it?.estado?.descripcion === 'Servicio Habilitado';
                    return (
                        <Card 
                            key={index}
                            sx={{
                                background: '#fafbfc !important',
                                borderRadius: 1.5,
                                overflow: 'hidden',
                                border: `1px solid ${isActive ? '#109569' : '#c63030'}`,
                                boxShadow: 'none',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    boxShadow: `0 2px 8px ${isActive ? 'rgba(16, 185, 129, 0.15)' : 'rgba(239, 68, 68, 0.15)'}`,
                                    borderWidth: '2px'
                                }
                            }}
                        >
                            {/* Header compacto con badge de estado */}
                            <Box
                                sx={{ 
                                    background: isActive ? '#109569' : '#c63030',
                                    px: 1.5,
                                    py: 0.75,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {isActive ? (
                                        <CheckCircleIcon sx={{ color: '#fff', fontSize: 18 }} />
                                    ) : (
                                        <CancelIcon sx={{ color: '#fff', fontSize: 18 }} />
                                    )}
                                    <Typography 
                                        sx={{
                                            color: '#fff',
                                            fontWeight: 600,
                                            fontSize: '0.875rem',
                                            letterSpacing: '-0.01em'
                                        }}
                                    >
                                        {it?.articulo?.nombre}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        px: 1,
                                        py: 0.25,
                                        borderRadius: 0.75,
                                        fontSize: '0.688rem',
                                        color: '#fff',
                                        fontWeight: 600,
                                        letterSpacing: '0.02em'
                                    }}
                                >
                                    <TextEstadoServicio descripcion={it?.estado?.descripcion} />
                                </Box>
                            </Box>

                            {/* Contenido organizado en tabla */}
                            <Box sx={{ p: 1.5 }}>
                                {/* Fila 1: Información principal */}
                                <Grid container spacing={1} sx={{ mb: 1 }}>
                                    <Grid item xs={3}>
                                        <Box>
                                            <Typography sx={{ fontSize: '0.625rem', color: '#9ca3af', fontWeight: 600, mb: 0.25, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                                Precio
                                            </Typography>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <AttachMoneyIcon sx={{ fontSize: 14, color: '#0364ff' }} />
                                                <Typography sx={{ fontSize: '0.875rem', fontWeight: 700, color: '#111827' }}>
                                                    {it?.articulo?.precio || '0'}
                                                </Typography>
                                                <Typography sx={{ fontSize: '0.688rem', color: '#6b7280' }}>
                                                    {it?.articulo?.moneda}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    
                                    <Grid item xs={3}>
                                        <Box>
                                            <Typography sx={{ fontSize: '0.625rem', color: '#9ca3af', fontWeight: 600, mb: 0.25, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                                Tipo
                                            </Typography>
                                            <Typography sx={{ fontSize: '0.813rem', fontWeight: 600, color: '#374151' }}>
                                                {it?.tipo || 'N/A'}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={2}>
                                        <Box>
                                            <Typography sx={{ fontSize: '0.625rem', color: '#9ca3af', fontWeight: 600, mb: 0.25, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                                Cant.
                                            </Typography>
                                            <Typography sx={{ fontSize: '0.813rem', fontWeight: 600, color: '#374151' }}>
                                                {it?.articulo?.cantidad || 'N/A'}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={2}>
                                        <Box>
                                            <Typography sx={{ fontSize: '0.625rem', color: '#9ca3af', fontWeight: 600, mb: 0.25, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                                Vigencia
                                            </Typography>
                                            <Chip
                                                label={it?.articulo?.vigencia === 'S' ? 'Sí' : 'No'}
                                                size="small"
                                                sx={{
                                                    height: 20,
                                                    fontSize: '0.688rem',
                                                    fontWeight: 600,
                                                    background: it?.articulo?.vigencia === 'S' ? '#dcfce7' : '#fee2e2',
                                                    color: it?.articulo?.vigencia === 'S' ? '#166534' : '#991b1b',
                                                    border: `1px solid ${it?.articulo?.vigencia === 'S' ? '#86efac' : '#fca5a5'}`
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                    {/* Fechas de vigencia en la misma fila */}
                                    {(it?.articulo?.vigencia_desde || it?.articulo?.vigencia_hasta) && (
                                        <Grid item xs={2}>
                                            <Box>
                                                <Typography sx={{ fontSize: '0.625rem', color: '#9ca3af', fontWeight: 600, mb: 0.25, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                                    {it?.articulo?.vigencia_desde && it?.articulo?.vigencia_hasta ? 'Periodo' : it?.articulo?.vigencia_desde ? 'Desde' : 'Hasta'}
                                                </Typography>
                                                <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#374151', lineHeight: 1.2 }}>
                                                    {it?.articulo?.vigencia_desde && FechaFunction.format(it?.articulo?.vigencia_desde, 'dd/MM/yy')}
                                                    {it?.articulo?.vigencia_desde && it?.articulo?.vigencia_hasta && ' - '}
                                                    {it?.articulo?.vigencia_hasta && FechaFunction.format(it?.articulo?.vigencia_hasta, 'dd/MM/yy')}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    )}
                                </Grid>

                                <Divider sx={{ my: 1, borderColor: '#e5e7eb' }} />

                                {/* Fila 2: Detalles comerciales */}
                                <Grid container spacing={1} sx={{ mb: 1 }}>
                                    <Grid item xs={6}>
                                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                                            <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>
                                                Condición:
                                            </Typography>
                                            <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#374151' }}>
                                                {it?.condicion_pago?.descripcion || 'N/A'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                                            <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>
                                                Contratista:
                                            </Typography>
                                            <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#374151' }}>
                                                {it?.contratista?.descripcion || 'N/A'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                                {/* Fila 3: Ubicación */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                                    <LocationOnIcon sx={{ fontSize: 14, color: '#6b7280' }} />
                                    <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>
                                        {it?.ubicacion?.domicilio || 'Sin dirección'}
                                    </Typography>
                                    {it?.ubicacion?.latitud && it?.ubicacion?.longitud && (
                                        <Typography sx={{ fontSize: '0.688rem', color: '#9ca3af', ml: 0.5 }}>
                                            ({it?.ubicacion?.latitud}, {it?.ubicacion?.longitud})
                                        </Typography>
                                    )}
                                </Box>

                                {/* Fila 4: Fechas del sistema (si existen) */}
                                {(it?.estado?.alta || it?.estado?.modificacion) && (
                                    <Box sx={{ display: 'flex', gap: 2, pt: 0.5, borderTop: '1px solid #f3f4f6' }}>
                                        {it?.estado?.alta && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <CalendarTodayIcon sx={{ fontSize: 12, color: '#9ca3af' }} />
                                                <Typography sx={{ fontSize: '0.688rem', color: '#6b7280' }}>
                                                    Alta: {FechaFunction.format(it?.estado?.alta, 'dd/MM/yy')}
                                                </Typography>
                                            </Box>
                                        )}
                                        {it?.estado?.modificacion && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <CalendarTodayIcon sx={{ fontSize: 12, color: '#9ca3af' }} />
                                                <Typography sx={{ fontSize: '0.688rem', color: '#6b7280' }}>
                                                    Modif: {FechaFunction.format(it?.estado?.modificacion, 'dd/MM/yy')}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                )}
                            </Box>
                        </Card>
                    );
                })}
            </Box>
        </Card>
    )
}

export default CardCuentaProducto